$(document).ready(function () {
	var bounds = new google.maps.LatLngBounds();
	var markers = new Array();
	var infowindows = new Array();
	var activeInfoWindows;

	var map = new google.maps.Map(document.getElementById('map'),
		{
			zoom: 4,
			center: { lat: 41.8719, lng: 12.5673 },
			disableDefaultUI: true,
			// gestureHandling: "greedy",
			styles: [
				{ "featureType": "administrative", "elementType": "all", "stylers": [{ "saturation": "-100" }] },
				{ "featureType": "administrative.province", "elementType": "all", "stylers": [{ "visibility": "off" }] },
				{ "featureType": "landscape", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 65 }, { "visibility": "on" }] },
				{ "featureType": "poi", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": "50" }, { "visibility": "simplified" }] },
				{ "featureType": "road", "elementType": "all", "stylers": [{ "saturation": "-100" }] },
				{ "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] },
				{ "featureType": "road.arterial", "elementType": "all", "stylers": [{ "lightness": "30" }] },
				{ "featureType": "road.local", "elementType": "all", "stylers": [{ "lightness": "40" }] },
				{ "featureType": "transit", "elementType": "all", "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }] },
				{ "featureType": "water", "elementType": "geometry", "stylers": [{ "hue": "#ffff00" }, { "lightness": -25 }, { "saturation": -97 }] },
				{ "featureType": "water", "elementType": "labels", "stylers": [{ "lightness": -25 }, { "saturation": -100 }] }
			]
		});

	google.maps.event.addListener(map, 'click', function (event) {
		for (var i = 0; i < infowindows.length; i++) {
			infowindows[i].close();
		}
	});



	var lang = "it";

	$.get(`/umbraco/surface/locations/getlocations?lang=${lang}`, function (_apiLocations) {
		$.each(_apiLocations, function (index, location) {
			var _locationCoords = { lat: location.latitude, lng: location.longitude };

			var infoContent = `
						<div class="infow-content">
							<h4>${location.name}</h4>
							<img src="${location.image}"/>
						</div>
					 `;

			var infowindow = new google.maps.InfoWindow({
				id: location.id,
				content: infoContent
			});

			google.maps.event.addListener(infowindow, 'domready', function () {

				// Reference to the DIV which receives the contents of the infowindow using jQuery
				var iwOuter = $('.gm-style-iw');
				iwOuter.css({ 'padding': '0' });

				$('.gm-style-iw-d').css({ 'overflow': 'hidden' });
				$('.gm-style-iw > button').css({ 'display': 'none' });

				var iwBackground = iwOuter.prev();

				// Remove the background shadow DIV
				iwBackground.children(':nth-child(2)').css({ 'display': 'none' });

				// Remove the white background DIV
				iwBackground.children(':nth-child(4)').css({ 'display': 'none' });
			});

			var marker = new google.maps.Marker({
				id: location.id,
				position: _locationCoords,
				map: map,
				title: location.name,
				icon: {
					url: '/assets/zanetti/images/map-marker.png'
				}
			});

			marker.addListener('click', function () {
				if (activeInfoWindows) { activeInfoWindows.close(); }
				infowindow.open(map, marker);
				activeInfoWindows = infowindow;
			});

			markers.push(marker);
			infowindows.push(infowindow);

			bounds.extend(_locationCoords);
		});

		map.fitBounds(bounds);

		// map zoom
		$('[data-action="map-zoom"]').unbind('click').click(function (e) {
			e.preventDefault();

			var _id = $(this).data('id');
			var _lat = $(this).data('lat');
			var _lng = $(this).data('lng');

			if (_lat && _lng) {
				var _currentMarker = $.grep(markers, function (x) { return x.id === _id; })[0];
				var _currentInfoWindow = $.grep(infowindows, function (x) { return x.id === _id; })[0];

				map.setCenter(new google.maps.LatLng(_lat, _lng));
				map.setZoom(14);

				if (activeInfoWindows) { activeInfoWindows.close(); }
				_currentInfoWindow.open(map, _currentMarker);
				activeInfoWindows = _currentInfoWindow;

				scrollToAnchor('map');
			}
		})
	});
});

function scrollToAnchor(aid) {
	var $aTag = $("a[name='" + aid + "'], #" + aid);

	if (!$aTag.length) return;

	$('html, body').animate({ scrollTop: $aTag.offset().top }, 'slow');
}